import type { PDFPageProxy } from 'pdfjs-dist/types/src/display/api';

import { SUPPORTED_FILE_EXTENSIONS } from './constants';

export const getPageDimensions = (props: { scale: number; page: PDFPageProxy }) => {
  const { scale, page } = props;
  const adjustedScale = scale * window.devicePixelRatio;
  const viewport = page.getViewport({ scale: adjustedScale });

  return {
    viewport,
    scaledHeight: viewport.height / window.devicePixelRatio,
    scaledWidth: viewport.width / window.devicePixelRatio,
  };
};

export const isFileExtensionSupported = (fileName: string): boolean => {
  const [fileExtension] = fileName.split('.').slice(-1);
  return SUPPORTED_FILE_EXTENSIONS.includes(fileExtension.toLowerCase());
};
